<template>
  <video-player
      :video-url="url"
      controls />
</template>

<script>
import BaseUI from '@riseupil/base-ui';

export default {
  name: 'InsightVideoPlayer',
  components: {
    VideoPlayer: BaseUI.VideoPlayer,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
  },
};

</script>

<style lang="scss">
</style>
